
/**
 * 콘텐츠 타입
 */
export type UpdateCourseDraft200LocalizedSectionsItemLecturesItemContentType = typeof UpdateCourseDraft200LocalizedSectionsItemLecturesItemContentType[keyof typeof UpdateCourseDraft200LocalizedSectionsItemLecturesItemContentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateCourseDraft200LocalizedSectionsItemLecturesItemContentType = {
  VIDEO: 'VIDEO',
  MARKDOWN: 'MARKDOWN',
  INTERACTIVE: 'INTERACTIVE',
  QUIZ: 'QUIZ',
} as const;
